import { BADGE_VARIANTS } from 'components/Badge'
import { CollectionStatus } from 'types/graphql-generated'
import { type StatusBadgeMapper } from './types'

export const COLLECTION_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [CollectionStatus.Published]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [CollectionStatus.InReview]: {
    variant: BADGE_VARIANTS.GRAY,
  },
  [CollectionStatus.NotPublished]: {
    variant: BADGE_VARIANTS.RED,
  },
}
